export enum DeviceExclusionReason {
  Other = 0,
  PendingInstall = 1,
  VoidProperty = 2,
  Refusal = 3,
  Faulty = 4,
  LostByUser = 5,
  Replaced = 6,
}

export interface IDeviceStatus {
  id: string;
  name: string;
  deviceType: string;
  customerName?: string;
  locationName: string;
  lastConnection: string;
  toBeDeleted: boolean;
  softwareVersion: number;
  lowBatteryWarning: number;
  lowBatteryLevel?: number;
  tasksToBase: number;
  tasksFromBase: number;
  additionalInfo?: string;
  additionalAlarmInfo?: string;
  address?: string;
  postCode?: string;
  postOffice?: string;
  batteryState: number;
  exclusionReason?: DeviceExclusionReason;
}

export type DeviceStatus =
  "online" |
  "offline" |
  "offlineUnder24h" |
  "lowBattery" |
  "inventory" |
  "everonInventory" |
  "service" |
  "lost" |
  "excluded" |
  "noStatus"

export const EXCLUSION_REASON_OPTIONS: { value: DeviceExclusionReason; key: string }[] = [
  { value: DeviceExclusionReason.PendingInstall, key: 'EXCLUSION_REASON_PENDING_INSTALL' },
  { value: DeviceExclusionReason.VoidProperty,   key: 'EXCLUSION_REASON_VOID_PROPERTY' },
  { value: DeviceExclusionReason.Refusal,        key: 'EXCLUSION_REASON_REFUSAL' },
  { value: DeviceExclusionReason.Faulty,         key: 'EXCLUSION_REASON_FAULTY' },
  { value: DeviceExclusionReason.LostByUser,     key: 'EXCLUSION_REASON_LOST_BY_USER' },
  { value: DeviceExclusionReason.Replaced,       key: 'EXCLUSION_REASON_REPLACED' },
  { value: DeviceExclusionReason.Other,          key: 'EXCLUSION_REASON_OTHER' },
];

export function getExclusionReasonKey(reason: DeviceExclusionReason): string {
  return EXCLUSION_REASON_OPTIONS.find(o => o.value === reason)?.key ?? 'EXCLUSION_REASON_OTHER';
}
